addEventListener('DOMContentLoaded', _ => {
    Object.defineProperty(document, 'top', {
        get() {
            return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
        },
    })
    const navElement = document.querySelector('#navigation')
    const nextSibling = navElement.parentElement.querySelector('#navigation + *')
    const mirror = navElement.cloneNode(true)
    mirror.classList.add('mirror')
    navElement.parentElement.insertBefore(mirror, nextSibling)
    addEventListener('scroll', _ => {
        if (document.top > navElement.clientHeight) {
            navElement.classList.add('scrolled')
        } else {
            navElement.classList.remove('scrolled')
        }
    })

    const hamburger = document.querySelector('#nav-toggle')
    const navItems = navElement.querySelectorAll('.navigation-items');
    const navItemsWrapper = navElement.querySelector('#navigation-items-wrapper');

    hamburger.addEventListener('click', _ => {
        navItemsWrapper.classList.toggle('open')
        hamburger.classList.toggle('opened')
    });

    const dropdowns = navElement.querySelectorAll('.dropdown');
    dropdowns.forEach(dropdown => {
        $(dropdown).on('show.bs.dropdown', _ => {
            const navToggle = navElement.querySelector('#nav-toggle');
            navToggle.classList.add('d-none');
        });
        $(dropdown).on('hide.bs.dropdown', _ => {
            const navToggle = navElement.querySelector('#nav-toggle');
            navToggle.classList.remove('d-none');
        });
    });

    window.onload = _ => {
        mirror.style.display = '';
    }
})